module.exports = __webpack_public_path__ + "static/media/1@3x.fba05f89.png";